import React from 'react'
import { styled } from '@mui/material/styles'
import dynamic from 'next/dynamic'
import { Container, Paper, Typography } from '@mui/material/'
import { CompanyInfoFragment } from '@services/cloud/client'

const PREFIX = 'CompanyMainInfoView'

const classes = {
  root: `${PREFIX}-root`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
}))

const DynamicAuthCheckButton = dynamic(import('./AuthCheckButton'), {
  ssr: false,
})

type Props = {
  company: CompanyInfoFragment
}

const CompanyMainInfoView = (props: Props) => (
  <Root>
    <Paper className={classes.root} elevation={0} variant="outlined">
      <Container maxWidth="md">
        <Typography variant="h5">{props.company.name}</Typography>
        <Typography>{props.company.description}</Typography>
        <DynamicAuthCheckButton company={props.company} />
      </Container>
    </Paper>
  </Root>
)

export default CompanyMainInfoView
